<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-success">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الإعدادات</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">

        <div v-if="isLoading == true"
          style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار </h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
        <div v-if="isLoggedIn == true && isLoading == false" class="d-flex flex-column flex-lg-row">
          <!-- Sidebar -->
          <div class="flex-column flex-lg-row-auto w-lg-250px w-xl-350px mb-10">
            <div class="card mb-5 mb-xl-8">
              <div class="card-body">
                <!--begin::Summary-->
                <!--begin::User Info-->
                <div class="d-flex flex-center flex-column py-5">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-100px symbol-circle mb-7">
                    <img :src="'/assets/img/user.png'" alt="image" />
                  </div>
                  <!--end::Avatar-->
                  <!--begin::Name-->
                  <a href="#" class="fs-3 text-gray-800 text-hover-primary fw-bold mb-3">
                    {{ student.fname }} {{ student.lname }}
                  </a>
                  <!--end::Name-->
                  <!--begin::Position-->
                  <div class="mb-9">
                    <!--begin::Badge-->
                    <div class="badge badge-lg badge-light-success d-inline">
                      طالب
                    </div>
                    <!--begin::Badge-->
                  </div>
                  <!--end::Position-->
                  <!--begin::Info-->
                  <!--begin::Info heading-->
                  <div class="fw-bold mb-3">
                    Watermark: {{ student.watermark_id }}
                    <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="popover" data-bs-trigger="hover"
                      data-bs-html="true" data-bs-content="Student unique identifier." data-kt-initialized="1"></i>
                  </div>
                  <!--end::Info-->
                </div>
                <!--end::User Info-->
                <!--end::Summary-->
              </div>
            </div>
          </div>
          <!-- Content -->
          <div class="flex-lg-row-fluid ms-lg-15">
            <!-- Tabs -->
            <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-8">
              <li class="nav-item">
                <a class="nav-link text-active-success pb-4 active" data-bs-toggle="tab"
                  href="#kt_user_view_overview_tab">
                  بياناتي
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link text-active-success pb-4" data-bs-toggle="tab" href="#kt_user_view_devices_tab">
                  الأجهزة المرتبطة
                </a>
              </li>
              <!-- Add more tabs if needed -->
            </ul>
            <!-- Tab content -->
            <div class="tab-content">
              <div class="tab-pane fade show active" id="kt_user_view_overview_tab" role="tabpanel">
                <div class="card pt-4 mb-6 mb-xl-9">
                  <div class="card-body p-9">
                    <!--begin::Input group-->
                    <div class="row mb-7">
                      <label class="col-lg-4 fw-semibold text-muted">البريد الإلكتروني:</label>
                      <div class="col-lg-8 fv-row">
                        <span class="fw-semibold text-gray-800 fs-6">{{
                          student.email
                        }}</span>
                      </div>
                    </div>
                    <!--end::Input group-->
                    <!--begin::Input group-->
                    <div class="row mb-7">
                      <label class="col-lg-4 fw-semibold text-muted">
                        رقم الهاتف
                        <span class="ms-1" data-bs-toggle="tooltip" aria-label="Phone number must be active"
                          data-bs-original-title="Phone number must be active" data-kt-initialized="1">
                          <i class="ki-duotone ki-information fs-7"><span class="path1"></span><span
                              class="path2"></span><span class="path3"></span></i>
                        </span>
                      </label>
                      <div class="col-lg-8 d-flex align-items-center">
                        <span class="fw-bold fs-6 text-gray-800 me-2">{{
                          student.mobile
                        }}</span>
                      </div>
                    </div>
                    <!--end::Input group-->
                    <!--begin::Input group-->
                    <div class="row mb-7">
                      <label class="col-lg-4 fw-semibold text-muted">Status</label>
                      <div class="col-lg-8">
                        <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-success">
                          <span v-if="student.status === '1'" class="badge badge-success">Active</span>
                          <span v-else class="badge badge-danger">Inactive</span>
                        </a>
                      </div>
                    </div>
                    <!--end::Input group-->
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="kt_user_view_devices_tab" role="tabpanel" dir="rtl">
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div class="card" dir="ltr">
                      <div v-if="isMaster" class="add-box p-5">
                        <button class="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#addDeviceModal">
                          <i class="fa fa-plus"></i> إضافة جهاز
                        </button>
                      </div>
                      <div class="card-body" v-if="devices && devices.length > 0">
                        <div v-for="device in devices" :key="device.device_id" class="device-card mb-4">
                          <div class="row">
                            <div class="col-8" style="direction: rtl">
                              <h5>{{ device.name }}</h5>
                              <p class="text-muted">
                                <span class="badge badge-primary" style="margin-left: 5px">{{ device.platform }}</span>
                                <span class="badge badge-info">{{
                                  device.location
                                }}</span>
                              </p>
                              <p class="text-muted">
                                Created At {{ device.created_at }}
                              </p>
                              <p class="text-muted">
                                <span v-if="device.active === '1'" class="badge badge-success">Active</span>
                                <span v-else class="badge badge-danger">Inactive</span>
                              </p>
                              <div class="mt-4" v-if="isMaster">
                                <button class="btn btn-dark btn-sm" @click="handleDelete(device.id)">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </div>
                            </div>
                            <div class="col-4 ms-auto">
                              <div v-if="qrCodeUrls[device.device_id]">
                                <img :src="qrCodeUrls[device.device_id]" alt="QR Code" class="img-fluid" />
                              </div>
                            </div>
                          </div>
                          <hr />
                        </div>
                      </div>
                      <!-- عرض رسالة التحميل في حال جلب البيانات -->
                      <div v-if="loading" class="text-center">
                        <p>Loading...</p>
                      </div>
                      <!-- عرض رسالة في حال عدم وجود أجهزة -->
                      <div v-if="!loading && (!devices || devices.length === 0)" class="text-center">
                        <p>No devices found.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Add more tab panes as per your requirement -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <addDevice />
</template>

<script>
import { apiUrl, deviceId } from "@/utils/api"; // Adjust the import path according to your project structure
import QRCode from "qrcode";
import addDevice from "./addDevice.vue";
import Swal from "sweetalert2";

export default {
  name: "Settings",
  components: {
    addDevice,
  },
  data() {
    return {
      devices: [],
      isLoggedIn: false,
      isLoading: true,
      isMaster: false,
      token: localStorage.getItem("access_token"),
      baseUrl: process.env.VUE_APP_BASE_URL, // Adjust as per your .env configuration
      student: {}, // To store the fetched student details
      walletBalance: 0,
      loading: true, // Add a loading state
      qrCodeUrls: {}, // تخزين روابط QR لكل جهاز
    };
  },
  mounted() {
    this.fetchStudentDetails();
    this.fetchDevices();
    this.isMasterDevice();
  },
  methods: {
    async fetchStudentDetails() {
      try {
        const response = await fetch(`${apiUrl}/desktop/my-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });
        if (response.status === 302 || response.redirected || !response.ok) {
          this.isLoggedIn = false;
          this.isLoading = false;

        } else {
          const data = await response.json();
          this.student = data.student;
          this.isLoggedIn = true;
          this.isLoading = false;

        }
      } catch (error) {
        console.error("Error fetching student details:", error);
      } finally {
        this.loading = false; // Set loading to false once data is fetched
      }
    },
    async fetchDevices() {
      try {
        const data = {
          user_device_id: deviceId, // Adjust if necessary
        };
        const response = await fetch(`${apiUrl}/devices`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        if (response.ok) {
          const responseData = await response.json();
          this.devices = responseData.devices || [];
          await this.generateQRCodes(); // توليد رموز QR بعد جلب الأجهزة
        } else {
          console.error("Failed to fetch device details");
        }
      } catch (error) {
        console.error("Error fetching device details:", error);
      } finally {
        this.loading = false;
      }
    },
    async isMasterDevice() {
      try {
        const data = {
          device_id: deviceId, // Adjust if necessary
        };
        const response = await fetch(`${apiUrl}/devices/is-master`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        if (response.ok) {
          const responseData = await response.json();
          // Check the result and set isMaster accordingly
          this.isMaster = responseData.result === true;
        } else {
          console.error("Failed to fetch device details");
          this.isMaster = false; // Default to false if the request fails
        }
      } catch (error) {
        console.error("Error fetching device details:", error);
        this.isMaster = false; // Default to false if an error occurs
      } finally {
        this.loading = false;
      }
    },
    async generateQRCodes() {
      for (let device of this.devices) {
        const qrCodeUrl = await this.generateQRCodeUrl(device.device_id);
        this.qrCodeUrls = { ...this.qrCodeUrls, [device.device_id]: qrCodeUrl };
      }
    },
    async generateQRCodeUrl(deviceId) {
      try {
        return await QRCode.toDataURL(deviceId, { errorCorrectionLevel: "H" });
      } catch (error) {
        console.error("Error generating QR code:", error);
        return "";
      }
    },
    async handleDelete(device_id) {
      const result = await Swal.fire({
        title: "هل أنت متأكد من  حذف الجهاز",
        text: " ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3ddc97",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "لا",
        confirmButtonText: "نعم",
      });

      if (result.isConfirmed) {
        try {
          const data = {
            id: device_id,
            user_device_id: deviceId, // Adjust if necessary
          };
          const response = await fetch(`${apiUrl}/devices/delete-device`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
          if (response.ok) {
            const responseData = await response.json();
            // Check the result and set isMaster accordingly
            Swal.fire({
              icon: "success",
              title: "تم حذف الجهاز بنجاح",
              text: "",
            }).then((result) => {
              if (result.isConfirmed) {
                location.reload();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "حدثت مشكلة",
              text: "",
            }).then((result) => {
              if (result.isConfirmed) {
                location.reload();
              }
            });
          }
        } catch (error) {
          console.error("Error fetching device details:", error);
          this.isMaster = false; // Default to false if an error occurs
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
